import React from 'react';
import { useSelector } from 'react-redux';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { get } from 'lodash';

import Button from 'components/ContentfulFields/Button';
import Divider from 'components/Ui/Divider';
import { withContent } from 'components/Content';
import { injectVariables } from 'utils/translation';
import { selectAcquisitionVariables } from 'containers/Landing/selectors';
import { getRegionalBrandName } from 'utils/domainHelper';

import styles from './deliveryService.scss';

const CONTENT_KEYS = {
  feature: 'Feature',
  disclaimer: 'Disclaimer',
};

const DeliveryService = ({ content, ctaClick }) => {
  const {
    feature: {
      fields: { title, description, images },
    },
    disclaimer,
  } = content;
  const acquisitionVariables = useSelector(selectAcquisitionVariables());
  const regionalBrandName = getRegionalBrandName();

  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => (
        <p className={styles.description}>{children}</p>
      ),
      [BLOCKS.EMBEDDED_ENTRY]: (node) => {
        const nodeType = get(node, 'data.target.sys.contentType.sys.id');
        const nodeContent = get(node, 'data.target');

        if (nodeType === 'button') {
          return (
            <Button
              document={nodeContent}
              className={styles.cta}
              onClick={ctaClick}
            />
          );
        }

        return null;
      },
    },
    renderText: (text) =>
      injectVariables(text, regionalBrandName, acquisitionVariables, ''),
  };

  return (
    <div className={styles.deliveryService}>
      <div className={styles.feature}>
        <img
          src={`${images[0].fields.file.url}?fm=webp`}
          alt={images[0].fields.file.description}
        />
        <div className={styles.content}>
          <h1 className={styles.title}>{title}</h1>
          {documentToReactComponents(description, options)}
        </div>
      </div>
      <Divider className={styles.divider} />
      <p className={styles.disclaimer}>
        {injectVariables(
          disclaimer,
          regionalBrandName,
          acquisitionVariables,
          '',
        )}
      </p>
    </div>
  );
};

export default withContent(CONTENT_KEYS)(DeliveryService);
